// removed by extract-text-webpack-plugin
module.exports = {"card":"card__card--936edc27","cardBody":"card__cardBody--ad6bf24f","cardBodyNarrow":"card__cardBodyNarrow--3db32319 card__cardBody--ad6bf24f","filterCard":"card__filterCard--12d35e92","filterCardLabel":"card__filterCardLabel--0fe3d8d7","center":"card__center--6faa51bb"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/ui/card.scss
// module id = 60
// module chunks = 0